import {
    Record,
    Datagrid,
    DateField,
    FunctionField,
    ListProps,
    NumberField,
    TextField,
    NullableBooleanInput, DateInput, AutocompleteInput, ReferenceInput, SingleFieldList, ChipField, ArrayField
} from "react-admin";
import {CustomList} from "../../components/CustomList";
import {IdentifierField} from "../../components/IdentifierField";

import {useOptionsResource} from "../../shared/hooks/useOptionsResource";
import {getDefaultListProps, initField} from "../../shared/utils";

import {DeliveryStatusChoice} from "../../shared/types";

import {hasPermission} from "../../authProvider";
import NotesCounter from "../../Distribution/Route/NotesCounter";
import {DriverCarrierField} from "../../Distribution/Route/DriverCarrierField";
import {DownloadFileButton} from "../../components/DownloadFileButton";
import {PrintA4} from "../../Distribution/Route/PrintA4";
import { PiMicrosoftExcelLogoBold } from "react-icons/pi";
import React from "react";
import {Print2XDocumentsButton} from "../../Distribution/Route/Print2XDocuments";
import {DriverField} from "../../components/DriverField";
import {Typography} from "@material-ui/core";
import {CarrierField} from "../../components/CarrierField";


const rowStyle = (record: any, index: any) => ({
    minHeight: "40px",
    height: "40px",
});

export const CarrierBorderauxList = (props: ListProps) => {
    const {data: options} = useOptionsResource("GET");

    const filters = options ? [
        <NullableBooleanInput {...initField("printed", options)} label="Stampato?" alwaysOn/>,
        <DateInput
            {...initField("planned_date", options)}
            label="Data pianificata" alwaysOn
        />,
    ] : [];

    if(props.permissions && props.permissions.includes("distribution.change_delivery") && options){
        filters.push(<ReferenceInput
            {...initField("carrier", options)}
            filter={{ type: "carrier" }}
            reference="autocomplete/subject"
            label="Vettore"
            className="filter-field-small"
            alwaysOn
        >
            <AutocompleteInput optionText="label" />
        </ReferenceInput>)
    }

    return options ? (
        <CustomList
            sort={{field: "id", order: "DESC"}}
            filters={filters}
            shouldExport={hasPermission(props.permissions, "base.export_carrierdelivery")}
            filterDefaultValues={{
                delivery_states: [DeliveryStatusChoice.DELIVERING],
                borderaux: true
            }}
            {...getDefaultListProps(props)}
            bulkActionButtons={false}
        >
            <Datagrid rowStyle={rowStyle}>
                {
                    props.permissions.includes("distribution.change_delivery") ?
                        <IdentifierField
                            {...initField("id", options)}
                            basePath="routes"
                        /> :
                        <TextField {...initField("id", options)} />
                }
                {
                    props.permissions.includes("distribution.change_delivery") &&
                    <DriverCarrierField label={"Autista/Vettore"}/>
                }
                <FunctionField
                    render={(record: Record | undefined) =>
                        record ? (
                            <PrintA4 mission_max_page={record.mission_max_page}/>
                        ) : null
                    }
                    label={"Stampa A4 "}
                />
                <FunctionField
                    render={(record: Record | undefined) =>
                        record ? (
                            <Print2XDocumentsButton mission_max_page={record.mission_max_page}/>
                        ) : null
                    }
                    label={"Stampa A5"}
                />
                <FunctionField
                    label={"Excel"}
                    render={(record: Record | undefined) =>
                        record ? (
                            <DownloadFileButton
                                title="Borderaux excel"
                                urlDownload={`carrier_routes/${record.id}/get_excel_borderau/`}
                                icon={<PiMicrosoftExcelLogoBold />}
                            />
                        ) : null
                    }
                />
                <DateField {...initField("planned_date", options)} showTime/>
                {
                    props.permissions.includes("distribution.change_delivery") &&
                    <DateField {...initField("printed_time", options)} showTime label="Data Stampa"/>
                }
                <ArrayField source="tags_objects" label="Tag">
                    <SingleFieldList>
                        <FunctionField
                            render={(record: any) => (
                                <ChipField size="small" source="label" />
                            )}
                        />
                    </SingleFieldList>
                </ArrayField>
                <NumberField {...initField("deliveries_num", options)} />
                )
                <FunctionField
                    render={(r: Record | undefined) => {
                        if (!r)
                            return null
                        if (r && r.driver)
                             return <DriverField source="driver" label={"Autista"} />
                        else
                            return (<Typography>-----------</Typography>)
                        }
                    }
                />
                <NotesCounter/>

            </Datagrid>
        </CustomList>
    ) : null;
};
